import { render, staticRenderFns } from "./PointIndex.vue?vue&type=template&id=0da7e99c&scoped=true"
import script from "./PointIndex.vue?vue&type=script&lang=js"
export * from "./PointIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7e99c",
  null
  
)

export default component.exports